import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import FormUser from "../forms/FormUser";

function CreateUser(props) {
  const history = useHistory();

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  return (
    <main className="createUser">
      <h1 className="title">Neuen Benutzer anlegen</h1>
      <p className="info">In diesem Bereich können Sie Benutzer anlegen, um ihnen Zugang zum Adminbereich zu ermöglichen.</p>
      <FormUser
        onCancel={e => {
          history.push("/");
        }}
      />
    </main>
  );
}
export default CreateUser;
